/**
 *
 * @param {"true" | "false"} string
 * @returns {Boolean}
 */
export const prepareBooleanString = (string: string): boolean => string.toLowerCase() === "true";
